module.exports = __webpack_public_path__ + "img/talron-plus.61d40df1.svg";